import { render, staticRenderFns } from "./bulk_history.vue?vue&type=template&id=14279c27&"
import script from "./bulk_history.vue?vue&type=script&lang=js&"
export * from "./bulk_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports